import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Main } from './pages/main';
import { I18nProvider } from './i18n';
import { publicIpv4 } from 'public-ip';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { useEffect, useState } from 'react';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export default function App({
  store,
  basename
}: {
  store: any;
  basename: any;
}) {
  const [ipAddress, setIpAddress] = useState<string | null>(null);

  useEffect(() => {
    const getIpAddress = async () => {
      try {
        const ip = await publicIpv4();
        setIpAddress(ip);
        console.log('Public IPv4:', ip);
      } catch (error) {
        console.error('Failed to get public IP:', error);
      }
    };

    getIpAddress();
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter basename={basename}>
        <I18nProvider>
          <Main />
        </I18nProvider>
      </BrowserRouter>
    </Provider>
  );
}
